import script from "./AllStaff.vue?vue&type=script&setup=true&lang=js"
export * from "./AllStaff.vue?vue&type=script&setup=true&lang=js"

import "./AllStaff.vue?vue&type=style&index=0&id=dd37dfa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd37dfa0"]])

export default __exports__